/**
 * A class to store confirm dialog data
 */
export class ConfirmDialogData {
  /**
   * @param title - The title of the confirm dialog
   * @param message - The message to display in the confirm dialog
   */
  constructor(public title: string, public message: string) {}
}
